import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=1828a110"
import script from "./AppModal.vue?vue&type=script&lang=js"
export * from "./AppModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports